import React, { useEffect } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import logo from '../../assets/logo-transparent.png';
import './Admin.css';

const NAV = [
  { to: '/admin/notices', label: '공지사항', icon: '📢' },
  { to: '/admin', label: '대시보드', icon: '📊', end: true },
  { to: '/admin/clients', label: '고객사 관리', icon: '🏢' },
  { to: '/admin/performances', label: '감리 실적', icon: '📋' },
  { to: '/admin/inquiries', label: '문의 내역', icon: '💬' },
];

export default function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('admin_token')) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const logout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  return (
    <div className="admin-root">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          <img src={logo} alt="HANGIL AI" />
        </div>
        <div className="admin-sidebar-title">관리 메뉴</div>
        <nav className="admin-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <button className="admin-logout-btn" onClick={logout}>
            로그아웃
          </button>
        </div>
      </aside>

      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
